import React from "react";

export const TextInput = ({
  name,
  type,
  value,
  onChage,
  label,
  autoComplete,
  required = false,
  placeholder,
  className = "",
  containerClassName = "",
  errorMessage,
}: Props) => {
  const resolvedClass = `${staticClass} ${className}`;
  const resolvedContainerClass = `${staticContainerClass} ${containerClassName}`;

  return (
    <div className={resolvedContainerClass}>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <input
        name={name}
        type={type}
        autoComplete={autoComplete}
        required={required}
        placeholder={placeholder}
        className={resolvedClass}
        value={value}
        onChange={onChage}
      />
      {errorMessage && (
        <p className="mt-1 text-red-500 text-xs italic">
          Please fill out this field.
        </p>
      )}
    </div>
  );
};

interface Props {
  name: string;
  type: string;
  value: string | number;
  onChage: React.ChangeEventHandler<HTMLInputElement> | undefined;
  label?: string;
  autoComplete?: string;
  required?: boolean;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  errorMessage?: string;
}

const staticClass = `
    appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm
    placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm
`;

const staticContainerClass = `flex-col space-y-1`;
